import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQLMutationObject,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { ADD_SELECTION_GIFT_MUTATION } from './addSelectionGiftMutation';
import { IPostGift, IPostGiftsResponse } from './model';

const mappingFunction = (result: IPostGiftsResponse): IGeneralRequestResponse<{ itemId: number }> =>
  result.addGiftSelection;

export const usePostGiftAwaitable = (): IHttpHookResponseAwaitable<
  IGeneralRequestResponse<{ itemId: number }>,
  IPostGift
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<{ itemId: number }>,
    IGraphQLMutationObject<IPostGift>,
    IPostGiftsResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.ECartApiKeys.CART_GIFTS_SELECTED_ADD_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(
    (data?: IPostGift) => {
      const payload = { query: ADD_SELECTION_GIFT_MUTATION, ...(data && { variables: { gift: data } }) };
      return awaitableRequest({ data: payload });
    },
    [awaitableRequest],
  );

  return { request };
};
